import _ from 'lodash';

import { getUUID } from 'utils/uuid';

import {
  PENDING_CHANGES_OPERATION_HEADER,
  WRITE_METHODS,
} from './pendingChangesOperation.constants';

const scope = { operationId: null };

/**
 * Runs one user action whose writes may land in several services (e.g. a modal saving the loan in
 * SkynetAPI and its custom fields in Loans). Every write sent while it runs carries one shared
 * operation id, so the pending changes they record are listed as one group, not one per request.
 */
export const runInPendingChangesOperation = async callback => {
  const previousOperationId = scope.operationId;

  scope.operationId = getUUID();

  try {
    return await callback();
  } finally {
    scope.operationId = previousOperationId;
  }
};

export const injectPendingChangesOperationHeader = httpApi =>
  httpApi.injectRequestInterceptor(config => {
    const isWrite = WRITE_METHODS.includes(_.toLower(config.method));

    if (_.isNil(scope.operationId) || !isWrite) {
      return config;
    }

    config.headers[PENDING_CHANGES_OPERATION_HEADER] = scope.operationId;

    return config;
  });
